export const setAuthToken = (data: any) => {
  sessionStorage.setItem("authInfo", data);
};
